<template>
  <div class="buy-card">
    <header>
      <img src="../../assets/images/card-img/buy-card-img/icon-24-fanhui.png" alt="" @click="$router.replace('/card-ecommend')"> 
      <p>
        购买康养会员卡
      </p>
    </header>
    <section>
      <!-- 服务类型 -->
      <div class="card-type">
        <!-- 底色 -->
        <div class="bag">
          <!-- 标题 -->
          <div class="title">
            服务类型
          </div>
          <!-- 具体类型 -->
          <div class="concreteness-type">
            <p class="time">
              十年卡
            </p>
            <div class="type-btm">
              <p>
                仅限4.30日之前购买
              </p>
              <p>
                <img src="../../assets/images/card-img/buy-card-img/duihao.png" alt="">
              </p>
              <p>
                <span>￥</span>
                <span>99</span>
                <span>元</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="personal-details">
        <div class="msg">
          <p>
            姓名  
          </p>
          <p>
            <input type="text" placeholder="请填写">
          </p>
        </div>
        <div class="msg">
          <p>
            身份证  
          </p>
          <p>
            <input type="text" placeholder="请填写">
          </p>
        </div>
        <div class="msg">
          <p>
            所在城市  
          </p>
          <p>
            <input type="text" placeholder="选择" readonly v-model="userlist.address" @click="showAddressChuang" style="width: 4.5rem">
          </p>
        </div>
      </div>
      <!-- 支付按钮 -->
      <div class="buy-btn">
        立即支付
      </div>
    </section>
    <van-popup v-model="showAddress" position="bottom" :style="{ height: '40%' }">
      <van-area
        :area-list="areaList"
        :value="areaCode"
        title="请选择你所在的城市"
        @confirm="sure"
        @cancel="exit"
        :columns-num="1"
        @change="change"
      />
    </van-popup>
  </div>
</template>
<script>

import Vue from 'vue';
import addressList from '../../../public/addressList/area1'
import { ActionSheet, Area, Popup} from 'vant';
Vue.use(ActionSheet);
Vue.use(Area);
Vue.use(Popup);

export default {
  data(){
    return{
      userlist: [], // 现住址
      showAddress: false, // 先住址弹窗
      areaList: addressList, // 选中省市区
      areaCode:'', // 选中省市区的code 
    }
  },
  methods:{
    // 收货地址
    showAddressChuang(){
      this.showAddress = true
    },
    // 选择地址完成按钮
    sure(val){
      this.showAddress = false
      // console.log(val)
      this.userlist.address = val[0].name
      // console.log(this.userlist)
    },
    // 选择地址取消按钮
    exit(){
      this.showAddress = false
    },
    change(event){
      // console.log(event)
    }
  },
}
</script>
<style lang="less" scoped>
  .buy-card{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
      // height: 100%;
      flex: 1;
      // 服务类型
      .card-type{
        width: 100%;
        height: 5.46rem;
        background-image: url(../../assets/images/card-img/buy-card-img/touming.png);
        background-size: 100% 5.46rem;
        overflow: hidden;
        // 底色
        .bag{
          width: 6.9rem;
          height: 4.46rem;
          margin: 0 auto;
          background: #ffffff;
          margin-top: 1rem;
          border-radius: .2rem .2rem 0 0;
          // 标题
          .title{
            font-family: PingFang-SC-Bold;
            color: #333333;
            font-size: 0.32rem;
            font-weight: bold;
            line-height: 1rem;
            margin-left: .3rem;
          }
          // 具体类型
          .concreteness-type{
            width: 6.32rem;
            height: 2.04rem;
            background: #FFF0DE;
            border: .01rem #EF8201 solid;
            border-radius: .1rem;
            margin-left: .29rem;
            position: relative;
            // 时间
            .time{
              font-size: 0.28rem;
              font-family: PingFang SC;
              font-weight: 400;
              color: rgba(51,51,51,1);
              line-height: .28rem;
              margin-top: .39rem;
              margin-left: .22rem;
            }
            .type-btm{
              display: flex;
              margin-top: .53rem;
              p{
                line-height: .24rem;
                &:first-child{
                  width: 2.67rem;
                  height: .39rem;
                  background-image: url(../../assets/images/card-img/buy-card-img/bag.png);
                  background-size: 2.67rem .39rem;
                  margin-left: .13rem;
                  font-family: PingFang-SC-Regular;
                  color: #FFFFFF;
                  font-size: 0.2rem;
                  text-align: center;
                  line-height: .3rem;
                  text-align: center;
                  line-height: .39rem;
                }
                &:nth-child(2){
                  img{
                    position: absolute;
                    width: .26rem;
                    height: .25rem;
                    right: 0;
                    bottom: 0;
                  }
                }
                &:last-child{
                  margin-left: 1.55rem;
                  span{
                    &:first-child{
                      font-family: PingFang-SC;
                      color: #333333;
                      font-size: 0.48rem;
                    }
                    &:nth-child(2){
                      font-family: KozGoPr6N;
                      font-weight: bold;
                      color: #EF8201;
                      font-size: 0.72rem;
                    }
                    &:last-child{
                      font-family: PingFang-SC;
                      color: #333333;
                      font-size: 0.36rem;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .personal-details{
        margin-top: -.97rem;
        .msg{
          width: 6.32rem;
          height: 0.88rem;
          margin: 0 auto;
          border-radius: .1rem;
          border: .01rem #E4E4E4 solid;
          margin-bottom: .21rem;
          p{
            &:first-child{
              float: left;
              line-height: .88rem;
              margin-left: .26rem;
              font-size: 0.3rem;
              font-family: PingFang SC;
              font-weight: 500;
              color: rgba(153,153,153,1);
            }
            &:last-child{
              float: right;
              margin-right: .26rem;
              display: flex;
              height: .88rem;
              align-items: center;
              input{
                font-size:0.28rem;
                font-family:PingFang SC;
                font-weight:400;
                color:rgba(153,153,153,1);
                text-align: right;
                border: none;
                outline: none;
              }
            }
          }
        }
      }
      // 购买按钮
      .buy-btn{
        width: 4.8rem;
        height: .88rem;
        background: #EF8201;
        margin: 0 auto;
        color: #ffffff;
        font-family: PingFang-SC-Bold;
        font-weight: Bold;
        font-size: .3rem;
        text-align: center;
        line-height: .88rem;
        margin-top: .5rem;
      }
    }
    .van-picker__cancel, .van-picker__confirm{
      color: red;
    }
  }
</style>